import Text from 'components/shared/Text'
import {
    VoucherPreviewCopy,
    VoucherPreviewDetails,
    VoucherPreviewHks,
    VoucherPreviewTitle,
    VoucherPreviewWrapper,
    VoucherPreviewInfo,
    VoucherPreviewQRCode,
    VoucherPreviewLeft,
    VoucherPreviewRight,
    VoucherPreviewDate,
} from './styles'
import Box from 'components/shared/Box'
import QRCode from 'assets/images/voucher/qrcode.png'
import TriLogo from 'assets/images/voucher/tri-logo-new.svg'
import Decor from 'assets/images/voucher/sun_palms.svg'
import moment from 'moment'
import { FormattedMessage, useIntl } from 'react-intl'
import { CardDetailDtoLimited } from 'store/api-slice/types'
import { CardPersonDto } from 'store/api-slice/hooks'

// ! voucher preview goes entirely in pl !

interface VoucherCardProps {
    voucherSignature: string
    voucherModel: {
        cardType?: CardDetailDtoLimited['cardType']
        personDetail: CardPersonDto
    }
}
const ProductVoucher = ({
    voucherSignature,
    voucherModel,
}: VoucherCardProps) => {
    const { formatMessage } = useIntl()
    const date = moment().add(12, 'months').format('DD.MM.YYYY')

    // TODO: think with backend how to pass multilingual descriptions for card vouchers
    // just to avoid static translations in frontend
    const guestTranslations = [
        {
            key: 'adult',
            translation: 'Dorosły',
        },
        {
            key: 'teen_reduced',
            translation: 'Dziecko (do 16 lat)',
        },
        {
            key: 'kid_to_120_cm',
            translation: 'Dziecko (do 120 cm)',
        },
        {
            key: 'discounted',
            translation: 'Z ulgą',
        },
    ]

    const resultDescription = guestTranslations.find(
        (guest) => guest.key === voucherModel.personDetail.key
    )

    return (
        <Box gap={4}>
            <Text variant="bodySmall" color="grayscale_900">
                {formatMessage({
                    id: 'selfcare.payment.personalize_voucher_preview_label',
                    defaultMessage: 'Podgląd Vouchera',
                })}
            </Text>
            <VoucherPreviewWrapper direction="row" justify="space-between">
                <VoucherPreviewLeft
                    isFullWidth
                    align={'center'}
                    justify={'space-between'}
                >
                    <Box
                        align="center"
                        mt={[20, 24]}
                        mb={[4, 8]}
                        style={{ flex: 1 }}
                    >
                        <VoucherPreviewTitle
                            variant="heading4"
                            color="grayscale_900"
                            align="center"
                            mb={[8, 12]}
                        >
                            VOUCHER
                        </VoucherPreviewTitle>
                        <VoucherPreviewDetails
                            variant="heading5"
                            color="grayscale_900"
                            align={'center'}
                        >
                            {voucherModel.cardType?.value.includes(
                                'unlimited_plus'
                            )
                                ? 'na kartę Unlimited+'
                                : 'na kartę Unlimited'}
                        </VoucherPreviewDetails>
                        <VoucherPreviewDetails
                            variant="heading5"
                            color="grayscale_900"
                            align={'center'}
                            mb={[8, 10]}
                        >
                            {resultDescription?.translation}
                        </VoucherPreviewDetails>
                        <VoucherPreviewDate
                            variant="heading5"
                            color="grayscale_900"
                            align={'center'}
                            mb={[6, 10]}
                        >
                            {`ważny do ${date} r.`}
                        </VoucherPreviewDate>
                        <VoucherPreviewHks
                            variant="heading5"
                            color="grayscale_900"
                            align={'center'}
                        >
                            FBG123456789
                        </VoucherPreviewHks>
                    </Box>
                    <VoucherPreviewQRCode align={'center'} gap={[2, 4]}>
                        <img src={QRCode} alt="" />
                        <VoucherPreviewInfo variant="bodyExtraSmall">
                            {/* keep Polish translation in different languages */}
                            <FormattedMessage
                                id="vouchers.preview.footer"
                                defaultMessage="Voucher do zrealizowania na <span>parkofpoland.com</span>"
                                values={{
                                    span: (chunks: string[]) => (
                                        <span
                                            style={{
                                                color: '#707070',
                                                fontWeight: 400,
                                            }}
                                        >
                                            {chunks}
                                        </span>
                                    ),
                                }}
                            />
                        </VoucherPreviewInfo>
                    </VoucherPreviewQRCode>
                </VoucherPreviewLeft>
                <VoucherPreviewRight justify={'space-between'} align={'center'}>
                    <Box minWidth={110} mb={[0, 2]} pl={10} pr={10}>
                        <img src={TriLogo} alt="Suntago - Samsung - Pepsi" />
                    </Box>
                    <VoucherPreviewCopy
                        variant="bodyStrong"
                        color="grayscale_900"
                        align={'center'}
                        as="pre"
                    >
                        {voucherSignature}
                    </VoucherPreviewCopy>
                    <Box minWidth={123} justify={'flex-end'}>
                        <img src={Decor} alt="" />
                    </Box>
                </VoucherPreviewRight>
            </VoucherPreviewWrapper>
        </Box>
    )
}
export default ProductVoucher
